<template>
  <div class="user">
    <userHead :userInfo="userInfo" :usertype="usertype"></userHead>
    <userOrder orderlistPath="/orderlist/0"></userOrder>
    <userlist :usertype="usertype"></userlist>
    <userTicketPurchase></userTicketPurchase>
  </div>
</template>

<script>
import userHead from '@/components/user/userHead';
import userlist from '@/components/user/userlist';
import userOrder from '@/components/user/userOrder';
import userTicketPurchase from '@/components/user/userTicketPurchase';
import { mapState } from "vuex";
export default {
  name: "user",
  data(){
    return {
      // userInfo: {}
      usertype: ''
    }
  },
  // created(){
  //   this.userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
  // },
  created(){
    console.log('几次')
    console.log(this.userInfo)
    if(this.userInfo && this.userInfo.extField1) {
      this.usertype = 'group'
    }else{
      this.usertype = 'user'
    }
  },
   computed: {
    ...mapState(['userInfo'])
  },
  components: {
    userHead,
    userlist,
    userOrder,
    userTicketPurchase
  }
};
</script>

<style scoped lang='less'>
.user{
  min-height: 100vh;
}
</style>
